import {
	GROUP_TYPE,
	CURSOR,
	getTextColor,
	GROUP_SECTION_WIDTH,
	drawRectangle,
	drawExpansionIcon,
	getTrimmedText,
	GROUP_SECTION_PADDING_LEFT,
	GROUP_SECTION_MARGIN_LEFT,
	GROUP_SECTION_SPACING_LEVEL_THREE,
	drawBorder,
	GROUP_SECTION_PROJECT_BORDER_WIDTH,
	GROUP_SECTION_TARGET_PHASE_BUTTON_SIZE,
	COMMON_IMAGE,
	GROUP_SECTION_EXPAND_ICON_WIDTH,
	GROUP_SECTION_EXPAND_ICON_HEIGHT,
} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import Util from '../../../../forecast-app/shared/util/util';
import {hasFeatureFlag} from "../../../../forecast-app/shared/util/FeatureUtil";

class PhaseGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PROJECT_SCHEDULING_PHASE, data);
	}

	refreshData(updatedPhase) {
		this.data.name = updatedPhase.name;
	}

	draw(canvasContext, x, y) {
		if (hasFeatureFlag("timeline_group_section_restyling")) {
			const width = GROUP_SECTION_WIDTH();
			const {data, height, expanded, groupType} = this;
			super.draw(x, y, width, height, this);
			const {name, id, faded, color, isInProjectGroup, projectGroupColor} = data;
			const cacheId = `${groupType}-${id}-${!!expanded}`;
			const borderThickness = 1;
			const connectedProjectOffset = isInProjectGroup ? GROUP_SECTION_PADDING_LEFT : 0;

			interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

			const cachedData = cacheManager.get(groupType, cacheId);
			if (cachedData) {
				canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
				return;
			}

			// draw left connected project border color
			if (isInProjectGroup && projectGroupColor) {
				drawBorder(
					canvasContext,
					x + GROUP_SECTION_MARGIN_LEFT - GROUP_SECTION_PROJECT_BORDER_WIDTH,
					y - 2 - (borderThickness * 2),
					height + (borderThickness * 2),
					true,
					projectGroupColor,
					GROUP_SECTION_PROJECT_BORDER_WIDTH,
				);
			}

			// right project border
			if (!isInProjectGroup) {
				drawBorder(
					canvasContext,
					x + width - GROUP_SECTION_PROJECT_BORDER_WIDTH,
					y - 2 - borderThickness,
					height + (borderThickness * 2) + 1,
					true,
					color,
					GROUP_SECTION_PROJECT_BORDER_WIDTH,
				);
			}

			const textColor = getTextColor();

			const drawGroup = () => {
				canvasContext.drawImage(
					cacheManager.getCommonImage(expanded ? COMMON_IMAGE.EXPAND_GROUP_ICON : COMMON_IMAGE.EXPAND_GROUP_CLOSED_ICON),
					x + GROUP_SECTION_SPACING_LEVEL_THREE + connectedProjectOffset - (GROUP_SECTION_EXPAND_ICON_WIDTH / 2),
					y + (height / 2) - (GROUP_SECTION_EXPAND_ICON_HEIGHT / 2),
					GROUP_SECTION_EXPAND_ICON_WIDTH,
					GROUP_SECTION_EXPAND_ICON_HEIGHT,
				);

				const fontSize = 13;
				canvasContext.fillStyle = `${textColor}${faded ? 'a1' : ''}`;
				canvasContext.font = `600 ${fontSize}px ` + Util.getFontFamily();
				const maxNameLength = GROUP_SECTION_WIDTH() -
					(connectedProjectOffset + GROUP_SECTION_SPACING_LEVEL_THREE + (GROUP_SECTION_PADDING_LEFT * 3) + GROUP_SECTION_TARGET_PHASE_BUTTON_SIZE);

				canvasContext.fillText(
					getTrimmedText(
						canvasContext,
						name,
						maxNameLength
					),
					x + connectedProjectOffset + GROUP_SECTION_SPACING_LEVEL_THREE + GROUP_SECTION_PADDING_LEFT,
					y + (height / 2) + (fontSize / 2) - borderThickness
				);
			};

			drawGroup();
		} else {
			const width = GROUP_SECTION_WIDTH();
			const {data, height, expanded, groupType} = this;
			super.draw(x, y, width, height, this);
			const {name, id, faded} = data;
			const cacheId = `${groupType}-${id}-${!!expanded}`;

			interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

			const cachedData = cacheManager.get(groupType, cacheId);
			if (cachedData) {
				canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
				return;
			}

			const textColor = getTextColor();

			const drawGroup = () => {
				if (data.isInProjectGroup) {
					canvasContext.fillStyle = data.projectGroupColor;
				}
				const xOffset = data.isInProjectGroup ? 16 : 10;
				drawRectangle(canvasContext, x + xOffset, y - 1, width - xOffset, height + 1, {
					borderColor: '#ebebee',
					borderThickness: 1,
				});

				drawExpansionIcon(canvasContext, x, y, width, height, {
					expanded,
				});

				canvasContext.fillStyle = `${textColor}${faded ? 'a1' : ''}`;
				canvasContext.font = '500 12px ' + Util.getFontFamily();
				canvasContext.fillText(getTrimmedText(canvasContext, name, 190), x + 24, y + 22);
			};
			drawGroup();
		}
	}
}

export default PhaseGroup;
